import { useTranslate } from '@tolgee/react';
import NewsListPage, { PageProps, getServerSideProps as ssr } from '@amf/shared/pages/NewsListPage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

export default function Page({ navigation, partners, news }: PageProps) {
  const { t } = useTranslate();
  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('news.list.title')} />
      <NewsListPage news={news} prefixes={{ newsList: AppLinks.newsList }} />
    </Layout>
  );
}

export const getServerSideProps = ssr;
